import { LocalizedText } from "@/i18n/LocalizedText";
import { Check, CircleMinus, X } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";
import { useSidebar } from "./ui/sidebar";
import { type Table } from "@tanstack/react-table";

const ActionsSuggested = ({
  rowSelection,
  table,
  customAction,
  noConfirmation = false,
  handleStatusChange,
  handleDeleteSelected,
}: {
  rowSelection: any;
  table: Table<any>;
  handleStatusChange: any;
  noConfirmation?: boolean;
  customAction?: any;
  handleDeleteSelected: any;
}) => {
  const { state } = useSidebar();

  return (
    <AlertDialog>
      <div
        style={{
          width:
            window.innerWidth >= 768
              ? `calc(100vw - ${state === "collapsed" ? "80" : "240"}px)`
              : "100%",
          left:
            window.innerWidth >= 768
              ? `${state === "collapsed" ? "80" : "240"}px`
              : "0",
        }}
        className={`border-t flex justify-center fixed transition-all duration-300 bottom-0 bg-white w-full md:w-auto`}
      >
        <div
          className={`${Object.keys(rowSelection).length > 0 ? "flex my-2" : "hidden"} border-[#898989] gap-2 w-fit bg-[#171717] text-[#FAFAFA] p-2 items-center rounded-lg justify-center`}
        >
          <div className="flex  w-fit items-center border border-[#898989] rounded-lg">
            <span className="mx-2 text-xs font-normal">
              {Object.keys(rowSelection).length} selected
            </span>
            <Separator
              orientation="vertical"
              className="bg-[#898989] data-[orientation=vertical]:h-[20px]"
            ></Separator>
            <Button
              disabled={table.getSelectedRowModel().rows.length === 0}
              onClick={() => table.resetRowSelection()}
              className="w-fit cursor-pointer has-[>svg]:px-2"
            >
              <CircleMinus size={16} />
            </Button>
          </div>
          <Separator
            orientation="vertical"
            className="bg-[#898989] data-[orientation=vertical]:h-[30px]"
          ></Separator>
          {noConfirmation ? (
            <div
              className="flex justify-center"
              onClick={() =>
                handleDeleteSelected(table, "suggested", null, false)
              }
            >
              <div
                className={`flex text-xs gap-2 px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${table.getSelectedRowModel().rows.length === 0 && "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50"}`}
              >
                <X size={16} /> <LocalizedText id="legacy.reject.1ih98sq" />
              </div>
            </div>
          ) : (
            <AlertDialogTrigger asChild>
              <Button
                type="button"
                disabled={table.getSelectedRowModel().rows.length === 0}
                className={`flex text-xs gap-2 px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${table.getSelectedRowModel().rows.length === 0 ? "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50" : ""}`}
              >
                {customAction ? (
                  <>
                    {customAction.icon} {customAction.title}
                  </>
                ) : (
                  <>
                    <X size={16} /> <LocalizedText id="legacy.reject.1ih98sq" />
                  </>
                )}
              </Button>
            </AlertDialogTrigger>
          )}

          {customAction ? null : (
            <button
              onClick={() => handleStatusChange(null)}
              className="flex justify-center"
            >
              <div
                className={`text-xs gap-2 flex px-2 py-2 border border-[#898989] rounded-md transition-colors 
                      duration-200 cursor-pointer hover:bg-primary/90 focus:outline-none 
                      focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary 
                      ${table.getSelectedRowModel().rows.length === 0 && "opacity-50 cursor-not-allowed pointer-events-none bg-primary/50 hover:bg-primary/50"}`}
              >
                <Check size={16} />{" "}
                <LocalizedText id="legacy.activate.1ps4pgc" />
              </div>
            </button>
          )}
        </div>
      </div>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="text-center">
            <LocalizedText id="legacy.are.you.sure.you.want.to.delete.item.1jv3i38" />
          </AlertDialogTitle>
          <AlertDialogDescription className="sr-only">
            {" "}
            <LocalizedText id="legacy.item.deletion.meaav8" />
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="cursor-pointer">
            <LocalizedText id="legacy.cancel.18x3nqb" />
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={() =>
              handleDeleteSelected(table, "suggested", null, false)
            }
            className="hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
          >
            <LocalizedText id="legacy.delete.16wmut8" />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ActionsSuggested;
